<template>
    <v-card>
        <v-card-title>
            <span class="headline">{{ editar ? 'Editar tipo cúpon' : 'Nuevo tipo cúpon' }}</span>
        </v-card-title>

        <v-card-text>
            <v-alert
                v-model="mostrar_alert"
                dismissible
                :type="type_alert"
            >
                <template v-html="html_alert"/>
            </v-alert>

            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex
                        xs12
                        sm6
                    >
                        <v-text-field
                            :value="item.nombre"
                            :error-messages="error_input.nombre"
                            label="Nombre"
                            @input="(payload) => form.nombre = payload"
                        />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                    >
                        <croppa
                            :width="200"
                            :initial-image="imageInitial"
                            :height="200"
                            v-model="image_data"
                            placeholder="Elige una imagen"
                            :file-size-limit="500 * 1024"
                            :zoom-speed="20"
                            :quality="1"
                            accept="image/png,image/jpg,image/jpeg"
                            @file-size-exceed="fileExceededLimit"
                        />
                        <p style="font-size: 8px;">
                            Se aceptan imagenes en formato PNG, JPEG o JPG. Las imágenes no deben ser de mas de
                            500k y automáticamente seran redimencionadas a 150 x 150 px
                        </p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="close"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="blue darken-1"
                class="white--text"
                :loading="loading"
                :disabled="loading"
                @click="guardar"
            >
                Guardar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import EventBus from "../EventBus";

    export default {
        name: "FormTipoCupon",
        props: {
            item: {
                type: [Array, Object],
                default: () => {
                    return {
                        id: 0,
                        nombre: '',
                    }
                }
            }
        },
        data() {
            return {
                form: {
                    nombre: '',
                },
                error_input: {
                    nombre: '',
                },
                loading: false,
                mostrar_alert: false,
                type_alert: 'success',
                html_alert: '',
                image_data: {},
            }
        },
        computed: {
            editar() {
                return this.item.id > 0;
            },
            imageInitial() {
                if (this.item.id) {
                    return this.item.img_url;
                }
                return '';
            }
        },
        watch: {
            item(val) {
                this.form = Object.assign({}, val);
            }
        },
        mounted() {
            this.image_data.refresh();
        },
        updated() {
            this.image_data.refresh();
        },
        methods: {
            close() {
                this.form.id = 0;
                this.form.nombre = '';
                this.$emit('close', true);
            },
            fileExceededLimit() {
                EventBus.$emit('tugarrafon:show-snackbar', {
                    color: 'warning',
                    text_content: 'El archivo supera los 500Kb permitidos'
                });
            },
            guardar() {
                let url_target = this.editar ? '/api/tipo-cupon/' + this.item.id : '/api/tipo-cupon';
                let method = this.editar ? 'put' : 'post';
                this.loading = true;
                this.error_input.nombre = '';

                let data = this.$_clonar(this.form);

                if (this.image_data.hasImage()) {
                    data.image = this.image_data.generateDataUrl();
                    data.image_name = 'data_image';
                }

                axios({
                    method: method,
                    url: url_target,
                    data: data
                })
                    .then((success) => {
                        let {data} = success;
                        this.loading = false;
                        /*window.console.log('IsData', data);*/
                        if (data.success) {
                            this.form.nombre = '';
                            this.$emit('save', data.message);
                        }
                    })
                    .catch((error) => {
                        this.loading = false;

                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            /*window.console.log(error.response.data);
                            window.console.log(error.response.status);
                            window.console.log(error.response.headers);
                            window.console.info("Es error");*/
                            if (error.response.status === 422) {
                                /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
                                this.error_input = Object.assign({}, error.response.data.data)
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            /*window.console.log(error.request);*/
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            /*window.console.log('Error', error.message);*/
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>
